import axios from "axios";
import React, { useState } from "react";
import "./extend.scss";
import ModalUmum from "../../../modalUmum/ModalUmum";
import moment from "moment";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";

function Extend() {
  const id = JSON.parse(window.localStorage.getItem("logId"));
  const idStaff = window.sessionStorage.getItem("dataLogin");
  const navigate = useNavigate()

  const [add, setAdd] = useState();
  const [exp, setExp] = useState();
  const [note, setNote] = useState();
  const [staff, setStaff] = useState();
  const [catatan, setcatatan] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [sehari, setSehari] = useState(false)
  const [seminggu, setSeminggu] = useState(false)
  const [empatBelas, setEmpatBelas] = useState(false)
  const [tigaMinngu, setTigaMinggu] = useState(false)
  const [empatMinggu, setEmpatMinggu] = useState(false)
  const [tigaPuluh, setTigaPuluh] = useState(false)
  const [sembilanPuluh, setSembilanPuluh] = useState(false)
  const [setahun, setSetahun] = useState(false)
  const [valRadio, setValRadio] = useState()
  const [duaBleasMinngu, setDuaBelasMinggu] = useState(false)


  //get staff by id
  const getStaffById = async () => {
    const rest = axios.create({
      baseURL: "https://mobile.amospa.com",
      headers: { Authorization: `Bearer ${idStaff}` },
    });
    const id = await rest.get("/jwt/token");
    let result = await axios.get(
      `https://mobile.amospa.com/staff/${id.data.data}`
    );
    setStaff(result.data.data[0]);
  };

  //Get Data Member by id
  const getData = async () => {
    const result = await axios.get(`https://mobile.amospa.com/users/${id}`);
    setAdd(result.data.data[0]);
  };

  const getNote = async () => {
    const result = await axios.get(`https://mobile.amospa.com/note/user/${id}`);
    const lastNote = result.data.data.length;
    setcatatan(result.data.data[lastNote - 1]);
  };

  const [image, setImage] = useState("");

  const updateMember = async () => {
    const data = new FormData();
    data.append("name", add.name);
    data.append("phone", add.phone);
    data.append("email", add.email);
    data.append("birthday", add.birthday);
    data.append("since", add.since);
    data.append("expired", exp);
    data.append("active", add.active);
    data.append("password", add.password);
    data.append("gender", add.gender);
    data.append("point", add.point);

    data.append("image", image);
    await axios.put(`https://mobile.amospa.com/users/${id}`, data);
    await axios.post(`https://mobile.amospa.com/note`, {
      userId: id,
      staffName: staff.name,
      catatan: note,
      keterangan: "Extend Member",
      lastScan: catatan.lastScan,
      visit: catatan.visit,
    });
    setModalShow(true);
  };
  console.log('catatan.lastScan', catatan);

  //Handle Next
  const handleNext = async () => {
    setModalShow(false);
    navigate("/homepage/members/")
  };

  useState(() => {
    getData();
    getStaffById();
    getNote();
  }, [modalShow]);

  return (
    <div>
      <div className="input-extend">
        <label>Expired Date :</label>
        <input type="date" value={exp} onChange={(e) => setExp(moment(e.target.value).parseZone().format('YYYY-MM-DD'))} />
      </div>
        <Form className="mb-3">
          {['checkbox'].map((type) => (
            <div key={`inline-${type}`} className="mb-3">
              <Form.Check
                inline
                label="1 day"
                value={1}
                name="group1"
                checked={sehari}
                type={type}
                id={`inline-${type}-1`}
                onClick={()=>{
                  setValRadio(1)
                  setSehari(true)
                  setSeminggu(false)
                  setEmpatBelas(false)
                  setTigaMinggu(false)
                  setEmpatMinggu(false)
                  setTigaPuluh(false)
                  setSembilanPuluh(false)
                  setSetahun(false)
                  setDuaBelasMinggu(false)
                  setExp(moment().add(1, 'days').parseZone().format('YYYY-MM-DD'))
                }}
              />
              
              <Form.Check
                inline
                label="1 Weeks"
                value={7}
                name="group1"
                checked={seminggu}
                type={type}
                id={`inline-${type}-1`}
                onClick={()=>{
                  setValRadio(1)
                  setSehari(false)
                  setSeminggu(true)
                  setEmpatBelas(false)
                  setTigaMinggu(false)
                  setEmpatMinggu(false)
                  setTigaPuluh(false)
                  setSembilanPuluh(false)
                  setSetahun(false)
                  setDuaBelasMinggu(false)
                  setExp(moment().add(7, 'days').parseZone().format('YYYY-MM-DD'))
                }}
              />

              <Form.Check
                inline
                label="2 Weeks"
                value={14}
                name="group1"
                type={type}
                checked={empatBelas}
                id={`inline-${type}-2`}
                onClick={()=>{
                  setValRadio(14)
                  setSehari(false)
                  setSeminggu(false)
                  setEmpatBelas(true)
                  setTigaMinggu(false)
                  setEmpatMinggu(false)
                  setTigaPuluh(false)
                  setSembilanPuluh(false)
                  setSetahun(false)
                  setDuaBelasMinggu(false)
                  setExp(moment().add(14, 'days').parseZone().format('YYYY-MM-DD'))
                }}
                  
              />

              <Form.Check
                inline
                label="3 Weeks"
                value={21}
                type={type}
                checked={tigaMinngu}
                id={`inline-${type}-3`}
                onClick={()=>{
                  setValRadio(21)
                  setSehari(false)
                  setSeminggu(false)
                  setEmpatBelas(false)
                  setTigaMinggu(true)
                  setEmpatMinggu(false)
                  setTigaPuluh(false)
                  setSembilanPuluh(false)
                  setSetahun(false)
                  setDuaBelasMinggu(false)
                  setExp(moment().add(21, 'days').parseZone().format('YYYY-MM-DD'))
                }}
              />

              <Form.Check
                inline
                label="4 Weeks"
                value={28}
                type={type}
                checked={empatMinggu}
                id={`inline-${type}-3`}
                onClick={()=>{
                  setValRadio(28)
                  setSehari(false)
                  setSeminggu(false)
                  setEmpatBelas(false)
                  setTigaMinggu(false)
                  setEmpatMinggu(true)
                  setTigaPuluh(false)
                  setSembilanPuluh(false)
                  setSetahun(false)
                  setDuaBelasMinggu(false)
                  setExp(moment().add(28, 'days').parseZone().format('YYYY-MM-DD'))
                }}
              />

              <Form.Check
                inline
                label="12 Weeks"
                value={84}
                type={type}
                checked={duaBleasMinngu}
                id={`inline-${type}-3`}
                onClick={()=>{
                  setValRadio(28)
                  setSehari(false)
                  setSeminggu(false)
                  setEmpatBelas(false)
                  setTigaMinggu(false)
                  setEmpatMinggu(false)
                  setTigaPuluh(false)
                  setSembilanPuluh(false)
                  setSetahun(false)
                  setDuaBelasMinggu(true)
                  setExp(moment().add(84, 'days').parseZone().format('YYYY-MM-DD'))
                }}
              />

              <Form.Check
                inline
                label="1 Month"
                value={30}
                type={type}
                checked={tigaPuluh}
                id={`inline-${type}-3`}
                onClick={()=>{
                  setValRadio(28)
                  setSehari(false)
                  setSeminggu(false)
                  setEmpatBelas(false)
                  setTigaMinggu(false)
                  setEmpatMinggu(false)
                  setTigaPuluh(true)
                  setSembilanPuluh(false)
                  setSetahun(false)
                  setDuaBelasMinggu(false)
                  setExp(moment().add(30, 'days').parseZone().format('YYYY-MM-DD'))
                }}
              />

              <Form.Check
                inline
                label="3 Month"
                value={90}
                type={type}
                checked={sembilanPuluh}
                id={`inline-${type}-3`}
                onClick={()=>{
                  setValRadio(84)
                  setSehari(false)
                  setEmpatBelas(false)
                  setTigaPuluh(false)
                  setSembilanPuluh(true)
                  setSetahun(false)
                  setDuaBelasMinggu(false)
                  setExp(moment().add(90, 'days').parseZone().format('YYYY-MM-DD'))
                }}
              />

              <Form.Check
                inline
                label="1 year"
                value={365}
                type={type}
                checked={setahun}
                id={`inline-${type}-3`}
                onClick={()=>{
                  setValRadio(365)
                  setSehari(false)
                  setEmpatBelas(false)
                  setTigaPuluh(false)
                  setSembilanPuluh(false)
                  setSetahun(true)
                  setDuaBelasMinggu(false)
                  setExp(moment().add(365, 'days').parseZone().format('YYYY-MM-DD'))
                }}
              />
            </div>
          ))}
        </Form>
      <div className="input-extend">
        <label>Note :</label>
        <input
          type="text"
          name="note"
          onChange={(e) => setNote(e.target.value)}
        />
      </div>
      <button
        type="button"
        className="btn btn-primary w-100 mt-3"
        onClick={() => updateMember()}
      >
        Save Extend
      </button>
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title="Extend Membership Success"
        nextButton={handleNext}
      />
    </div>
  );
}

export default Extend;
